import { Action } from 'redux'
import { CountryCode } from '../../../i18n/countryCodes'
import { IObjectType } from '../../../models/ObjectType'
import { ObjectType } from '../../../reducers/userObject/actionNames'

export const requestObjectTypeChange = (
  lang: CountryCode,
): IObjectTypeUpdate => ({
  lang,
  type: ObjectType.RequestUpdate,
})

export interface IObjectTypeUpdate extends Action<ObjectType.RequestUpdate> {
  lang: CountryCode
}

export const objectTypeAccepted = (
  objectTypes: IObjectType[],
): IObjectTypeAccepted => ({
  objectTypes,
  type: ObjectType.ObjectAccepted,
})

export interface IObjectTypeAccepted extends Action<ObjectType.ObjectAccepted> {
  objectTypes: IObjectType[]
}
